<template>
  <svg
      :fill="color"
      :height="height"
      :width="width"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 350 350"
  >
    <g id="SVGRepo_iconCarrier">
      <g>
        <path d="M319.971,152.464c-0.842-7.348-4.186-13.776-8.996-18.051C309.908,60.114,249.764,0,175.971,0 S42.031,60.114,40.965,134.413c-4.807,4.273-8.15,10.695-8.994,18.038c-13.549,3.284-23.643,15.511-23.643,30.057v31.863 c0,14.545,10.094,26.772,23.643,30.057c1.523,13.268,11.221,23.533,22.926,23.533H66.73c12.76,0,23.139-12.194,23.139-27.184 v-84.676c0-8.378-3.244-15.881-8.332-20.871c0.631-52.146,42.748-94.373,94.434-94.373s93.801,42.226,94.435,94.371 c-5.092,4.99-8.338,12.494-8.338,20.873v84.676c0,14.363,9.535,26.152,21.559,27.113v23.824c0,16.263-13.23,29.494-29.494,29.494 h-24.27c-3.127-9.141-11.797-15.734-21.982-15.734h-16.178c-12.811,0-23.232,10.423-23.232,23.234 c0,12.811,10.422,23.233,23.232,23.233h16.178c10.186,0,18.855-6.592,21.982-15.733h24.27c24.533,0,44.494-19.96,44.494-44.494 v-23.824c10.988-0.877,19.895-10.805,21.344-23.475c13.547-3.285,23.643-15.502,23.643-30.045v-31.863 C343.613,167.964,333.518,155.748,319.971,152.464z M31.756,228.387c-5.006-2.684-8.428-7.947-8.428-14.016v-31.863 c0-6.068,3.422-11.334,8.428-14.018V228.387z M207.881,336.941h-16.178c-4.539,0-8.232-3.693-8.232-8.233 c0-4.54,3.693-8.234,8.232-8.234h16.178c4.539,0,8.232,3.694,8.232,8.234C216.113,333.248,212.42,336.941,207.881,336.941z M74.869,240.777c0,6.49-3.803,12.184-8.139,12.184H54.896c-4.336,0-8.141-5.693-8.141-12.184v-84.676 c0-6.49,3.805-12.184,8.141-12.184H66.73c4.336,0,8.139,5.693,8.139,12.184V240.777z M175.971,25.857 c-57.854,0-105.356,45.584-109.186,103.063c-0.02,0-0.037-0.002-0.055-0.002H56.178C60.021,65.448,112.275,15,175.971,15 c63.693,0,115.947,50.449,119.791,113.918h-10.551c-0.016,0-0.031,0.002-0.047,0.002C281.334,71.441,233.826,25.857,175.971,25.857 z M305.184,240.777c0,6.49-3.803,12.184-8.141,12.184h-11.832c-4.338,0-8.143-5.693-8.143-12.184v-84.676 c0-6.49,3.805-12.184,8.143-12.184h11.832c4.338,0,8.141,5.693,8.141,12.184V240.777z M328.613,214.371 c0,6.069-3.422,11.335-8.43,14.018v-59.895c5.008,2.684,8.43,7.945,8.43,14.014V214.371z"></path>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#fff"
    },
    width: {
      type: String,
      default: "35"
    },
    height: {
      type: String,
      default: "35"
    }
  }
};
</script>

<style lang="scss" scoped>
</style>